export const SAVE_DETAILS_SUCCESS = `SAVE_DETAILS_SUCCESS`
export const RESET_SAVED_DETAILS = `RESET_SAVED_DETAILS`
export const TOGGLE_TERMS_AND_CONDITIONS = `TOGGLE_TERMS_AND_CONDITIONS`
export const TOGGLE_MARKETING_OFFERS = `TOGGLE_MARKETING_OFFERS`

